module.exports = __webpack_public_path__ + "img/safff.e6675869.webp";